/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Reviewstitle1Inputs */

const he_extension_reviewstitle1 = /** @type {(inputs: Extension_Reviewstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מה המשתמשים שלנו אומרים`)
};

const en_extension_reviewstitle1 = /** @type {(inputs: Extension_Reviewstitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What Our Users Say`)
};

/**
* | output |
* | --- |
* | "What Our Users Say" |
*
* @param {Extension_Reviewstitle1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_reviewstitle1 = /** @type {((inputs?: Extension_Reviewstitle1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Reviewstitle1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_reviewstitle1(inputs)
	return en_extension_reviewstitle1(inputs)
});
export { extension_reviewstitle1 as "extension_reviewsTitle" }